exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lots {\n  padding: 0 20px; }\n  .lots__items {\n    display: grid;\n    grid-gap: 20px;\n    padding: 40px 0;\n    grid-template-columns: repeat(1, 1fr); }\n\n@media only screen and (min-width: 640px) {\n  .lots__items {\n    grid-template-columns: repeat(2, 1fr); } }\n\n@media only screen and (min-width: 870px) {\n  .lots__items {\n    grid-template-columns: repeat(3, 1fr); } }\n\n@media only screen and (min-width: 1240px) {\n  .lots__items {\n    grid-template-columns: repeat(4, 1fr); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/BIDS_PAGE/components/Lots/index.scss
// module id = 265
// module chunks = 0